<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

onMounted(async () => {
  // 初始化認證狀態
  await authStore.init()
})
</script>

<template>
  <div class="min-h-screen bg-dark">
    <RouterView />
  </div>
</template>
